<template>
    <div>
        <Alert v-if="data.errorMessage" type="error" :message="data.errorMessage" show-icon class="mb-3"></Alert>
        <!-- eslint-disable-next-line vue/no-mutating-props-->
        <Tabs type="card" v-model:activeKey="data.tabKey" >
            <TabPane key="login" :tab="$t('views.login.auth')" :forceRender="true">
                <Form :colon="false" :ref="(e) => (refs.form = e)" layout="vertical">
                    <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields"></TemplateBuilder>
                </Form>
                 <div class="d-flex">
                    <router-link :to="{ name: 'register' }">
                        <Button>
                            <span>{{ $t("button.register") }}</span>
                        </Button>
                    </router-link>
                    <Button class="ml-auto px-3 btn-primary" @click="() => onClickLogin({ props, data, refs })" :disabled="isLoading">
                        <CIcon file="login.svg"></CIcon>
                        <span>{{ $t("button.login") }}</span>
                    </Button>
                </div>
                <div class="d-flex">
                    <router-link :to="{ name: 'forgot-password' }"> {{ $t("button.forgotPassword") }} ? </router-link>
                </div>
            </TabPane>
            <TabPane key="news" :tab="$t('views.login.news')" :forceRender="true">
                <Row align="middle">
                    <Col :xs="24" :md="12">
                        <Card class="cursor-pointer mr-2 info-btn" :bodyStyle="{ padding: '16px', textAlign: 'center'  }" @click="() => onClickNews({ key: 'faqs'})" >
                            <div><img :src="require(`../../../assets/icon/qa.svg`)" style="width:100%"/></div>
                            <span>{{ $t("model.faq.name") }}</span>
                        </Card>
                    </Col>
                    <Col :xs="24" :md="12">
                        <Card class="cursor-pointer mr-2 info-btn" :bodyStyle="{ padding: '16px', textAlign: 'center' }" @click="() => onClickNews({ key: 'laws'})" >
                            <div><img :src="require(`../../../assets/icon/balance.svg`)" style="width:100%"/></div>
                            <span>{{ $t("model.law.name") }}</span>
                        </Card>
                    </Col>
                </Row>
            </TabPane>
        </Tabs>
    </div>
</template>

<script>
import { Alert, Button, Form, Tabs, Card, Row, Col  } from "ant-design-vue";
import { defineAsyncComponent, defineComponent, reactive } from "vue";
import { isLoading, initForm, onClickLogin, onClickNews } from "./login.logic";

export default defineComponent({
    components: {
        TemplateBuilder: defineAsyncComponent(() => import("../../../components/input/template-builder/TemplateBuilder")),
        Form,
        Button,
        Card,
        Alert,
        Tabs,
        Row,
        Col,
        TabPane: Tabs.TabPane,
        CIcon: defineAsyncComponent(() => import("../../../components/icon/CIcon")),
    },
    setup(props) {
        const data = reactive({ rowProp: { gutter: 24 }, errorMessage: null });
        const refs = reactive({ form: null });
        initForm({ props, data, refs });
        return { props, data, refs, isLoading, onClickLogin, onClickNews };
    },
});
</script>

<style scoped>
    .info-btn {
        border-radius: 10px !important;
        border: 2px solid #8DD8CC!important;
    }

    .blue-white-green-color {
        background-color: #8DD8CC !important;
    }

</style>
